module.exports = __webpack_public_path__ + "media/images/talent/lp/ambassador/mv-bg-38f1ebfc68849e5dc9221f3641ee32e3.png";